import { Button } from "@/components/ui/button";
import { Navigation } from "lucide-react";

export const directionsUrl = (lat, lng) => `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;

// Buka Google Maps (tab baru / aplikasi di HP) dengan rute ke koordinat.
export function ArahkanButton({ lat, lng, testid, label = "Arahkan", iconOnly }) {
  if (lat == null || lng == null) return null;
  return (
    <Button size={iconOnly ? "icon" : "sm"} variant={iconOnly ? "ghost" : "outline"} asChild data-testid={testid}
            title={`Arahkan ke ${lat}, ${lng} di Google Maps`}>
      <a href={directionsUrl(lat, lng)} target="_blank" rel="noreferrer">
        <Navigation className={iconOnly ? "h-4 w-4 text-[#0055FF]" : "mr-1 h-3.5 w-3.5"} />{!iconOnly && label}
      </a>
    </Button>
  );
}
